import { HistoryTarget, INVOICE_MANAGEMENT_SECTION_ID, RECEIVED_NOTES_PANEL_ID } from './monthlyInvoiceView';

export type InvoiceManagementTab = 'monthly' | 'received';

export const INVOICE_MANAGEMENT_TAB_LABELS: Record<InvoiceManagementTab, string> = {
  monthly: 'Controle mensal',
  received: 'Notas recebidas',
};

export function initialInvoiceManagementTab(): InvoiceManagementTab {
  return 'monthly';
}

export function canOpenInvoiceManagement(role?: string | null): boolean {
  return role === 'admin' || role === 'hr' || role === 'manager';
}

export function panelVisibility(tab: InvoiceManagementTab): { monthly: boolean; received: boolean } {
  return {
    monthly: tab === 'monthly',
    received: tab === 'received',
  };
}

export function afterTabChange<T>(panelState: T): T {
  return panelState;
}

export interface ReceivedNotesFocus {
  tab: 'received';
  sectionId: string;
  userId: string | null;
  userName: string | null;
  competence: string;
  invoiceId: string | null;
  invoiceNumber: string | null;
  banner: string;
}

export function openReceivedNotes(target: HistoryTarget): ReceivedNotesFocus {
  const who = target.userName || 'o colaborador';
  const note = target.invoiceNumber ? ` Nota ${target.invoiceNumber}.` : '';
  return {
    tab: 'received',
    sectionId: RECEIVED_NOTES_PANEL_ID,
    userId: target.userId,
    userName: target.userName,
    competence: target.competence,
    invoiceId: target.invoiceId,
    invoiceNumber: target.invoiceNumber,
    banner: `Revisão de ${who} na competência ${target.competence}.${note} O visualizador abaixo é o mesmo já usado para buscar, aprovar e ver o histórico.`,
  };
}

export function managementSectionId(): string {
  return INVOICE_MANAGEMENT_SECTION_ID;
}
